module.exports = __webpack_public_path__ + "img/aParty_111523_A.8ca3b909.jpg";